import React from 'react';
// import Dashboard from '../dashboard/components/Dashboard';
import AdminDashboard from '../adminDashboard/AdminDashboard';
import Cookies from 'js-cookie';
import { decryptData } from 'utils/crypto';

const Index = () => {
  const roleId = Number(decryptData(Cookies.get('role_id')));

  // checking the type of roleId

  // superAdmin and admin roles
  return (
    <>
      {/* {roleId === 1 || roleId === 2 ? <AdminDashboard /> : <Dashboard />} */}
      <AdminDashboard />
    </>
  );
};

export default Index;